import { FC } from "react";

import { Image, Button, Link, Paragraph, RouterLink } from "capitalrx-components-2.0";
import { Logo } from "capitalrx-components-2.0/lib/general";
import { NavbarProps } from "./NavbarProps";
import { contactUsPressed } from "../../utils/contactUsPressed";

import styles from "./Navbar.module.scss";
import cn from "classnames";

import AdvantageLogo from "@/static/images/advantage-logo.svg?url";
import { useGroupNumber } from "@/utils/useGroupNumber";

const Navbar: FC<NavbarProps> = ({ className }: NavbarProps) => {
  const navbarContainerClasses = cn(styles["navbarContainer"], className);
  const groupNumber = useGroupNumber();

  const homeURL = groupNumber ? `/${groupNumber}` : "/";

  return (
    <div className={navbarContainerClasses}>
      <RouterLink to={homeURL} className={styles.navbarLeftSide} testId="advantage-home-link">
        <Image src={AdvantageLogo} alt="Capital Rx Advantage Savings" className={styles.advantageLogo} ariaHidden="true" />
        <span>Capital Rx Advantage Savings</span>
      </RouterLink>
      <div className={styles.navbarRightSide}>
        <Paragraph size="small" className={styles.poweredBy}>
          Powered by
        </Paragraph>
        <Link href="https://cap-rx.com/" className={styles.linkToCorporate} testId="capital-rx-home-link">
          <span aria-hidden="true">
            <Logo name="caprx-horizontal" testId="capital-rx-logo-footer" className={styles.capitalrxLogo} />
          </span>
          <span className="companyName">Capital Rx</span>
        </Link>
        <Button className={styles.contactUsButton} key={0} onClick={contactUsPressed} size="xsmall" testId="contact-us-link">
          CONTACT US
        </Button>
      </div>
    </div>
  );
};

export default Navbar;
